import axios from "axios";
import { authHeader } from "../../authServices/auth.header";
import { getServerList } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class ServerService {
  async getServerList(filter = "") {
    return await axios
      .get(API_URL + `pbx-app/pbx-server` + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async addServer(data) {
    return await axios
      .post(API_URL + `pbx-app/pbx-server`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        getServerList();
        return response.data;
      });
  }
  async getServerDetails(server_id) {
    return await axios
      .get(API_URL + `pbx-app/pbx-server?id=${server_id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async updateServer(server_id, data) {
    return await axios
      .put(API_URL + `pbx-app/pbx-server/${server_id}`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        getServerList();
        return response.data;
      });
  }
  async deleteServer(server_id) {
    return await axios
      .delete(API_URL + `pbx-app/pbx-server/${server_id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        getServerList();
        return response.data;
      });
  }
}

export default new ServerService();
